(function () {
  // Rewritten from the original scraped bundle to drop its jQuery dependency
  // ($(block), .data(), .find()) -- this theme never actually loads jQuery
  // anywhere, so every call into it threw "$ is not defined" and silently
  // aborted before Swiper ever initialized. Swiper itself doesn't need
  // jQuery at all, so this is a straight port to native DOM APIs with
  // identical behavior.
  const slideshow = () => {
    const syncSlideContentAnimation = (swiperElement, activeIndex) => {
      if (!swiperElement) return;
      swiperElement.querySelectorAll(".slideshow__content").forEach((slide, index) => {
        slide.classList.toggle("is-current", index === activeIndex);
      });
    };

    document.querySelectorAll(".slideshow").forEach((block) => {
      // Shopify's Section Rendering API wraps every section in
      // <div id="shopify-section-...">, not a <section> tag (unlike the
      // original scraped theme), so look for that wrapper first.
      const box = block.closest(".shopify-section") || block.closest("section");
      const id = box && box.getAttribute("id");
      if (!id) return;

      const slideCount = block.querySelectorAll(".slideshow__content").length;
      const autoplay = block.dataset.autoplay === "true";
      const stopAutoplay = block.dataset.stopAutoplay === "true";
      const delay = parseFloat(block.dataset.delay) * 1000;
      const speed = parseFloat(block.dataset.speed) * 1000;
      const effect = block.dataset.effect;

      const swiperParams = { speed, keyboard: true, loop: slideCount > 1 };
      const autoplayParams = autoplay
        ? { autoplay: { delay, disableOnInteraction: false, pauseOnMouseEnter: stopAutoplay } }
        : {};

      const swiperTextSelector = `#${id} .slideshow__tabs-wrapper`;
      const swiperTextElement = document.querySelector(swiperTextSelector);
      const swiperImgSelector = `#${id} .slideshow__contents-wrapper`;
      const swiperImgElement = document.querySelector(swiperImgSelector);

      if (slideCount === 1) {
        syncSlideContentAnimation(swiperImgElement, 0);
        swiperImgElement && swiperImgElement.classList.add("no_slideshow");
        swiperTextElement && swiperTextElement.classList.add("no_slideshow");
        return;
      }

      if (swiperTextElement && swiperTextElement.swiper) return;

      const swiperText = new Swiper(swiperTextSelector, {
        ...swiperParams,
        spaceBetween: 24,
        direction: "horizontal",
        slidesPerView: "auto",
        allowTouchMove: false,
        breakpoints: {
          990: { allowTouchMove: true },
          1600: { allowTouchMove: false, touchRatio: 0, keyboard: { enabled: false } },
        },
        on: {
          init: function () {
            swiperTextElement.classList.add("first_step");
          },
          slideChange: function () {
            swiperTextElement.classList.remove("first_step");
          },
        },
      });

      const swiperImg = new Swiper(swiperImgSelector, {
        pagination: { el: `#${id} .swiper-pagination`, clickable: true },
        ...swiperParams,
        ...autoplayParams,
        effect,
        thumbs: { swiper: swiperText },
        on: {
          init: function () {
            swiperImgElement.classList.add("first_step");
            box.style.setProperty("--bullet-duration", `${delay}ms`);
            syncSlideContentAnimation(swiperImgElement, this.realIndex);
          },
          slideChange: function () {
            box.style.setProperty("--bullet-duration", `${delay + speed}ms`);
            syncSlideContentAnimation(swiperImgElement, this.realIndex);
          },
          slideChangeTransitionEnd: function () {
            swiperImgElement.classList.remove("first_step");
          },
        },
      });

      if (autoplay && stopAutoplay) {
        swiperImgElement.addEventListener("mouseenter", function () {
          swiperTextElement.classList.add("stop_move");
        });
        swiperImgElement.addEventListener("mouseleave", function () {
          swiperTextElement.classList.remove("stop_move");
        });
      }
    });
  };

  document.addEventListener("DOMContentLoaded", function () {
    slideshow();
    document.addEventListener("shopify:section:load", function () {
      slideshow();
    });
  });
})();
